<div id="heigh-blood-pressure" class="flex flex-col max-h-screen -m-6">
    <ng-container *transloco="let t">
        <!-- Header -->
        <!-- <div
            class="flex flex-none items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary"
        >
            <div class="text-lg font-medium">
                {{ t("HEIGH-BLOOD-PRESSURE-THRESHOLDS") }}
            </div>
        </div> -->

        <!-- Body -->
        <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
            <h3 class="text-lg font-semibold mb-4">
                {{ t("PLEASE-ENTER-IMEI-NUMBER") }}
            </h3>

            <mat-form-field class="w-full mb-2">
                <!-- <mat-label>{{ t("imei") }}</mat-label> -->
                <input
                    matInput
                    id="imei"
                    [formControl]="imeiControl"
                    type="number"
                />
                @if (imeiControl.hasError('pattern') ) {
                <mat-error>{{ t("PLEASE-ENTER-VALID-IMEI") }}</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Actions -->
        <div
            class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black/10"
        >
            <!-- Discard -->
            <button
                class="ml-auto sm:ml-0"
                mat-stroked-button
                (click)="close()"
            >
                {{ t("CANCEL") }}
            </button>
            <!-- Send -->
            <button
                class="order-first sm:order-last"
                mat-flat-button
                [color]="'primary'"
                [disabled]="imeiControl.invalid"
                (click)="save()"
            >
                {{ t("SAVE") }}
            </button>
        </div>
    </ng-container>
</div>
